import Logo from '@assets/logo-cargill-center.svg';
import { CircularProgress, Stack, Typography } from '@mui/material';

interface IInitialLoadingProps {
  text: string;
}

export function InitialLoading({ text }: IInitialLoadingProps) {
  return (
    <Stack
      sx={{
        width: '100%',
        height: '100dvh',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img src={Logo} alt="Logo Feed Manager" height={52} style={{ marginBottom: 32 }} />

      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 2,

          position: 'absolute',
          bottom: 48,
          left: 48
        }}
      >
        <CircularProgress color="inherit" size={24} />

        <Typography variant="body1">{text}</Typography>
      </Stack>
    </Stack>
  );
}
